import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _PulseLoader from 'react-spinners/PulseLoader.js';
import { memo } from 'react';
const PulseLoader = _PulseLoader.default || _PulseLoader;
import { COLORS } from '@astrumu/core-ui-branding';
import { FlexContainer } from '../../CSS/index.js';
const Primary = memo(props => {
    const { size = 15, color, isLoading = true } = props;
    if (isLoading) {
        return (_jsx(FlexContainer, { style: {
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                height: '100%'
            }, children: _jsx(PulseLoader, { size: size, color: color || COLORS.defaultColors.secondaryAccentColor }) }));
    }
    return null;
});
export default Primary;
//# sourceMappingURL=index.js.map